/* eslint-disable */
export default {
  account: 'Konto',
  contact: 'Kontakt',
  lead: 'Lead',
  opportunity: 'Möglichkeit',
  case: 'Kundenvorgang',
  chooseEntity: 'Entitätstyp auswählen',
  create: 'Erstellen',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
